import React from "react";
import Main from "./components/Main.js";

import "../public/robots.txt";
import "../public/favicon.ico";
import "../public/manifest.json";

const App = () => {
    return (
        <div className="App">
            <Main />
        </div>
    );
}

export default App;